import { createFileRoute } from '@tanstack/react-router'
import { LoansPage } from '@/features/employee-portal/pages/LoansPage'

export const Route = createFileRoute('/employee/loans/')({
  component: LoansPage,
})
